import { useEffect } from 'react'
import { useMutation } from 'react-query'
import { useUserProfile } from 'core/hooks/useDataHook'
import AppLoadingIndicator from 'core/components/loaders/AppLoadingIndicator'
import useNavigation from 'core/hooks/useNavigation'
import { useLocation } from 'react-router-dom'
import { DashboardUrl, StartUrl } from 'constants/RouteUrls'
import APIService from 'api/APIService'
import { setAuthTokenCookie } from 'utils/AppHelper'

const SltLoginPage = () => {
  const { push, replace } = useNavigation()
  const location = useLocation()
  const slt = new URLSearchParams(location.search).get('slt')
  const redirect_url = new URLSearchParams(location.search).get('redirect_url')
  const { setData } = useUserProfile()
  const { isLoading, isError, mutate, data } = useMutation(
    ['stg-login'],
    APIService.users.login,
    {
      onSuccess: (user) => {
        setAuthTokenCookie(user.auth_token)
        setData(user)
        setTimeout(() => {
          push(redirect_url || DashboardUrl)
        }, 2000)
      },
      onError: () => {
        setTimeout(() => {
          replace(StartUrl)
        }, 3000)
      }
    }
  )
  useEffect(() => {
    if (slt) {
      mutate({
        single_login_token: slt,
        mixpanel_distinct_id: window?.mixpanel?.get_distinct_id?.()
      })
    }
  }, [mutate, slt])

  if (isLoading)
    return <AppLoadingIndicator overrideTitle="Logging you in..." />
  if (isError)
    return (
      <AppLoadingIndicator
        overrideTitle={
          <p>
            Unfortunately the token you provided was expired.
            <span className="mt-4 block  text-dark-4">
              Going back to login page...
            </span>
          </p>
        }
      />
    )
  if (data)
    return <AppLoadingIndicator overrideTitle={`Welcome back, ${data.email}`} />
  return null
}
export default SltLoginPage
